import React, { FC } from 'react';
import { AText, Box, Button } from '@alf/uikit';
import { Support } from '@namespace/auth';
import { useConfig, useGeneralRoutes } from '@namespace/cms';
import { LocalizedLink, useI18n } from '@namespace/i18n';
import { Icon, Image } from '@namespace/icons2';
import { HTMLSnippet } from '@namespace/snippets';
import { useGoPrevPageBeforeDep } from '../../hooks';

import styles from './index.module.css';

type PendingDepositProps = {
  id: string;
};

export const PendingDeposit: FC<PendingDepositProps> = ({ id }) => {
  const { config } = useConfig(id);
  const { snippetId, isShowSupport } = config;

  const { t } = useI18n();
  const onClose = useGoPrevPageBeforeDep();
  const { games, preMatchSport } = useGeneralRoutes();

  return (
    <Box direction="column">
      {snippetId ? (
        <HTMLSnippet snippetId={snippetId} />
      ) : (
        <Box direction="column" align="center" className={styles.content}>
          <Image name="general/pending2" className={styles.image} />

          <AText
            color="po_txt_color_1"
            size="2xl"
            breed="BU"
            className={styles.title}
            align="center"
          >
            {t('web.deposit.pending.info')}
          </AText>

          <Button
            size="xl"
            intent="primary"
            actionType="color1"
            className={styles.button}
            component={LocalizedLink}
            to={games}
          >
            {t('web.deposit.success.casino')}
          </Button>

          <Button
            size="xl"
            intent="primary"
            actionType="color1"
            className={styles.button}
            component={LocalizedLink}
            to={preMatchSport}
          >
            {t('web.deposit.success.sport')}
          </Button>
        </Box>
      )}

      <Box onClick={onClose} className={styles.close}>
        <Icon size="m" color="bg_color_4" name="icons/general/action/close" />
      </Box>

      {isShowSupport && <Support />}
    </Box>
  );
};
